window.jQuery.FroalaEditor.DEFAULTS.key = 'lJCJWECHICc2JOZWJ==';



// WEBPACK FOOTER //
// ./src/froala-key.js